module.exports = __webpack_public_path__ + "d769ce19cd0e8583f6be07231cd13034.svg";